import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconHarness = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "22.82px",
	height: "24.5px",
	viewBox: "0 0 22.82 24.5",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(3.5 0.9499998)",
		children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", {
			transform: "translate(0.7026493 0.70358557)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M9.10821 17.0228C9.10821 14.5242 7.08269 12.4987 4.58409 12.4987C2.08549 12.4987 0.0599676 14.5242 0.0599591 17.0228C0.0599506 19.5214 2.08546 21.547 4.58406 21.547C7.08267 21.547 9.10821 19.5215 9.10821 17.0228L9.10821 17.0228Z",
					fill: "none",
					stroke: "currentColor",
					strokeWidth: 1.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.55546 1.98428C8.5547 0.887565 7.66547 -0.000582316 6.56918 2.23366e-07C5.4729 0.000582986 4.58461 0.889675 4.58502 1.98596C4.58543 3.08224 5.47438 3.97067 6.57066 3.97044C7.09726 3.97032 7.60225 3.76099 7.97448 3.3885C8.34672 3.01601 8.55571 2.51088 8.55546 1.98428L8.55546 1.98428Z",
					fill: "none",
					stroke: "currentColor",
					strokeWidth: 1.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("g", {
					transform: "translate(4.584084 7.7825413)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M0 9.70499L12.0097 0",
						fill: "none",
						fillRule: "evenodd",
						stroke: "currentColor",
						strokeWidth: 1.5,
						strokeLinecap: "round",
						strokeLinejoin: "round"
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M5.06938 4.00416C3.18628 5.72706 0 8.67537 0 10.0563C0 11.4373 5.35138 7.73289 8.83745 11.0428",
					fill: "none",
					stroke: "currentColor",
					strokeWidth: 1.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M3.28559 6.06621C4.89216 5.86196 6.50748 6.37254 7.70478 7.46307",
					fill: "none",
					stroke: "currentColor",
					strokeWidth: 1.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		}) })
	}) })
});
export { SvgIconHarness as ReactComponent };
